import { generateInitialQuery, getSelectedStepDetailsById, isDataSource, isSourceAvailableInQuery } from "@utils";
import { hasValue } from "uxp/components";
export function updateStep(query, selectedStepId, field, value) {
    return updateFieldValue(query, selectedStepId, field, value);
}
export function updateSource(query, selectedStepId, field, source) {
    if (!hasValue(field) || !source)
        return;
    const _query = updateFieldValue(query, selectedStepId, field, source.id);
    if (isDataSource(source)) {
        if (!isSourceAvailableInQuery(_query, source.id)) {
            _query.sources.push(source);
        }
        else {
            // replace params 
            for (const s of _query.sources) {
                if (s.id == (source === null || source === void 0 ? void 0 : source.id))
                    s.params = Object.assign({}, ((source === null || source === void 0 ? void 0 : source.params) || []));
            }
        }
    }
    return _query;
}
function updateFieldValue(query, selectedStepId, field, value) {
    const { step, index, previousSteps } = getSelectedStepDetailsById(query, selectedStepId);
    const _query = generateInitialQuery(query);
    const _step = Object.assign({}, step);
    _step[field] = value;
    _query.steps.splice(index, 1, _step);
    return _query;
}
